module.exports = __webpack_public_path__ + "static/over-ons-1e0d8a1909b5bf7063534c520557ae31.jpeg";